var _circle, _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg14DaysIconSmall = function Svg14DaysIconSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 37,
    viewBox: "0 0 40 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 18.5,
    r: 16.5,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.345
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 18.5,
    r: 14.5,
    fill: "#9A27D5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 18.5,
    r: 14.5,
    fill: "url(#14-days-icon-small_svg__a)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.655 1.75c-4.52 0-8.74 1.795-11.898 5.055a.74.74 0 0 1-1.044.015.76.76 0 0 1-.013-1.06C12.134 2.205 16.736.25 21.655.25c4.83 0 9.375 1.899 12.793 5.346 3.419 3.447 5.302 8.031 5.302 12.904 0 4.873-1.876 9.457-5.294 12.904-3.418 3.447-7.963 5.346-12.793 5.346-4.83 0-9.374-1.899-12.793-5.346C5.452 27.957 3.57 23.373 3.57 18.5v-.815l-.428.431-1.63 1.644a.733.733 0 0 1-1.043 0 .753.753 0 0 1 0-1.06l3.316-3.344a.733.733 0 0 1 1.044 0l3.309 3.345c.29.292.29.764.002 1.057a.737.737 0 0 1-1.046.002l-1.63-1.643-.427-.432v.815c0 9.24 7.45 16.758 16.62 16.758 9.168 0 16.619-7.517 16.619-16.758 0-9.24-7.451-16.758-16.62-16.75Zm0 0V2v-.25Z",
    fill: "#9A27D5",
    stroke: "#9A27D5",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m15 15.425 2.8-2.1v10.8m0 0h-2.1m2.1 0h2.1M29 20.5h-7.5c1.338-2.748 2.766-4.689 4.87-7.238a.299.299 0 0 1 .53.19v10.673",
    stroke: "#9A27D5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "14-days-icon-small_svg__a",
    x1: 3.052,
    y1: 10.79,
    x2: 22.483,
    y2: 37.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F4F7",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8F8F9"
  })))));
};
export default Svg14DaysIconSmall;